export default __webpack_public_path__ + "assets/be0069.svg";